<template>
  <div class="app-messages_am" :class="{ [`am_${mode}`]: true }" v-if="messages.length">
    <div
      v-for="(m, i) in messages"
      :key="`app-message-${i}`"
      class="am_message">
      {{ m }}
    </div>
  </div>
</template>

<script>
export default {

  props: {
    messages: Array,
    mode: { // error || info
      type: String,
      default: 'default',
    },
  },

  data() {
    return {

    };
  },

};
</script>

<style lang="scss" scoped>
@import '../styles/common/main';

.app-messages_am {
  margin: 20px 0;
  padding: 10px 30px;
  clear: both;
  border-radius: 10px;
  text-align: center;
  font-size: 15px;
  &.am_default {
    background: #fff;
    color: #000;
  }
  &.am_error {
    background: $error-color;
    color: #000;
  }
  &.am_info {
    background: #9bd7a8;
  }
  .am_message {
    margin: 7px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppMessages.vue